<template>
    <div v-if="object && object.length > 0" class="filter-row filter-row-choose" @click="openModal">    
        <div class="filter-name">
            {{ name }}
        </div>
        <div class="filter-items-choosed" v-if="choicedItem">
            <!-- <template v-for="item in object"> -->
                <span class="filter-item">
                    {{ choicedItem.meta.title }}
                </span>
                <span v-if="selectedCount > 1" class="filter-item filter-count">
                    + {{ selectedCount - 1 }}
                </span>
            <!-- </template> -->
        </div>
        <span v-if="selectedCount == 0" class="filter-items-all">
            Все
        </span>
        <button @click="cleanFilter" v-else type="button" class="btn-delete">
            <svg class="icon">
                <use xlink:href="/img/front/icons/svgmap.svg#close" />
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    mixins: [],
    props: {
        object: {
            requeired: true
        },
        checked_data: {
            requeired: true
        },
        name: {
            requeired: true
        },
        system_name: {
            requeired: true
        }
    },
    computed: {
        choicedItem() {
            return this.object.filter(obj => {
                return obj.id === this.checked_data[0];
            })[0];
        },
        selectedCount() {
            return this.checked_data.length;
        }
    },
    methods: {
        openModal(event) {
            if (!event.target.closest('.btn-delete')) {
                this.$emit("open", this.system_name);
            }
        },
        cleanFilter() {
            this.$emit("clean", { clean_name: this.system_name  });
        }
    }
}
</script>